import Immutable from 'immutable';
import * as types from '../actionTypes/relatedTransactionActionTypes';
import { createReducer } from '../utils';

const initialStateValue = {
  data_ready: false,
  data: [],
  receipt: {},
  lastUpdated: '',
  error: {},
};

const initialState = Immutable.fromJS(initialStateValue);


export default createReducer(initialState, {
  [types.REQUEST_RELATED_TRANSACTION_DATA]: state =>
    state.merge(initialStateValue),

  [types.RECEIVE__RELATED_TRANSACTION_DATA]: (state, action) => state.mergeDeep({
    data_ready: true,
    data: action.data,
    lastUpdated: action.lastUpdated,
    receipt: action.receipt,
  }),

  [types.SERVICE_ERROR]: (state, action) =>
    state.mergeDeep({ data_ready: true, error: action.error }),
});



// WEBPACK FOOTER //
// ./src/redux/reducers/relatedTransactionReducer.js